<template>
    <vue-modal
        v-model="isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :modalBodyClass="$prefixClass.modal + '-optimization-result'"
    >
        <vue-optimization-result-content v-model="isVisible"></vue-optimization-result-content>
    </vue-modal>
</template>

<script>
export default {
    name: 'VueModalOptimizationResult',
    props:{
        value: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    data(){
        return{
        }
    },
    created() {
    },
    methods:{
    }
}
</script>

<style lang="scss">
    .#{$modal}-optimization-result {
        .#{$modal} {
            &-body {
                padding: 32px 40px;
            }
        }
    }
</style>